

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const BULKUPLOADDESIGNATION= createAsyncThunk(
  "bulkUploadDesignations/bulkUploadDesignations",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const bulkUploadDesignationsSlice = createSlice({
  name: "bulkUploadDesignationsSlice",
  initialState: {
    bulkUploadDesignations: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfbulkUploadDesignations: (state) => {
        state.bulkUploadDesignations.loading = false
        state.bulkUploadDesignations.error = false
        state.bulkUploadDesignations.data = []
        state.bulkUploadDesignations.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(BULKUPLOADDESIGNATION.fulfilled, (state, action) => {
      state.bulkUploadDesignations = {
        ...state.bulkUploadDesignations,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(BULKUPLOADDESIGNATION.pending, (state, action) => {
      state.bulkUploadDesignations = {
        ...state.bulkUploadDesignations,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(BULKUPLOADDESIGNATION.rejected, (state, action) => {
      state.bulkUploadDesignations = {
        ...state.bulkUploadDesignations,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const bulkUploadDesignationsAction = {
    BULKUPLOADDESIGNATION,
};

export { bulkUploadDesignationsAction };
export default bulkUploadDesignationsSlice.reducer;
export const {setInitialStateOfbulkUploadDesignations} = bulkUploadDesignationsSlice.actions
